export enum fileSources {
  users = 1,
  receiveTransaction = 2,
  moveTransaction = 3,
  issueTransaction = 4,
  disposeTransaction = 5,
  returnTransaction = 6,
  stockItem = 7,
  pictures = 8,
  documents = 9,
  videos = 10,
  purchaseOrder = 11,
  salesOrder = 12,
  category = 13,
  picklist = 14,
  assetModel = 15,
  asset = 16,
  assetMoveTransaction = 17,
  assetReceiveTransaction = 18,
  assetCheckOutTransaction = 19,
  assetPurchaseOrder = 20,
  assetCheckInTransaction = 21,
  assetDisposeTransaction = 22,
  assetTransferRequest = 23,
  assetPhysicalInventory = 24,
  assetReservation = 25,
  assetDepreciation = 26,
  stockCheckOutTransaction = 27,
  stockCheckInTransaction = 28,
  inventoryAdjustTransaction = 29
}